import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/features/me/NotificationsPage";

export const Route = createFileRoute("/app/me/notifications")({ component: NotificationsPage });
